// Disable eslint for this file as polyfills are often written in a way that doesn't
// agree with linting or best practices
// oxlint-disable-next-line unicorn/no-abusive-eslint-disable -- legacy code
/* eslint-disable */

// Load global polyfills...
// isomorphic-fetch as this is supplied in the main base container
require('isomorphic-fetch');

// Object.assign polyfill for IE
if (typeof Object.assign !== 'function') {
  Object.assign = function (target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (let index = 1; index < arguments.length; index++) {
      const source = arguments[index];
      if (source != null) {
        for (const key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

// Polyfil abort controller throwIfAborted - for supporting ios safari < 15
if (!AbortSignal.prototype.throwIfAborted) {
  AbortSignal.prototype.throwIfAborted = function () {
    if (this.aborted) {
      throw new DOMException('The operation was aborted.', 'AbortError');
    }
  };
}
